import * as pdfjsLib from 'pdfjs-dist'
import 'pdfjs-dist/build/pdf.worker.mjs'
import type { TextContent } from 'pdfjs-dist/types/src/display/api'

// Configure the worker source
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.mjs',
    import.meta.url,
).toString()

function pdfTextContentToText(textContent: TextContent): string {
    return textContent.items
        .filter((item) => 'str' in item)
        .map((item) => item.str)
        .join(' ')
}

export async function pdfToText(
    pdfData: Blob,
    mode: PdfToTextMode,
): Promise<string> {
    try {
        const data = new Uint8Array(await pdfData.arrayBuffer())
        const pdfDoc = await pdfjsLib.getDocument({ data }).promise
        let text = ''
        if (mode === 'snippet') {
            const page = await pdfDoc.getPage(1)
            const textContent = await page.getTextContent()
            text = pdfTextContentToText(textContent)
        } else if (mode === 'full') {
            for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
                const page = await pdfDoc.getPage(pageNum)
                const textContent = await page.getTextContent()
                text += pdfTextContentToText(textContent)
            }
        }
        return text
    } catch (error) {
        console.error('Error extracting text from PDF:', error)
        return ''
    }
}

export type PdfToTextMode = 'snippet' | 'full'
